import { render, staticRenderFns } from "./IconSvgRar.vue?vue&type=template&id=56e3dc50&scoped=true&"
import script from "./IconSvgRar.vue?vue&type=script&lang=js&"
export * from "./IconSvgRar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3dc50",
  null
  
)

export default component.exports